/**
 * Create root saga for the store by combining all watcher sagas
 */
// Library Methods
// sagsa

// Common Sagas
import { bulkPaymentLinkSaga } from 'containers/BulkPaymentLink/redux/BulkPaymentLink.sagas';
import { all } from 'redux-saga/effects';
import { merchantSagas } from '../containers/MerchantOnboard/redux/merchantOnBoard.sagas';
import { userManagementSaga } from '../containers/UserManagement/redux/userManagement.sagas';
import { transactionsSaga } from '../containers/Transactions/redux/transactions.sagas';
import { refundSaga } from '../containers/Refund/redux/refund.sagas';
import { paymentLinkSaga } from '../containers/PaymentLink/redux/paymentLink.sagas';
import { roleManagementSaga } from '../containers/RoleManagement/redux/roleManagement.sagas';
import { userVerificationSaga } from '../containers/UserVerification/redux/userVerification.sagas';
import { roleVerificationSaga } from '../containers/RoleVerification/redux/roleVerification.sagas';
import { pgConfigDataSagas } from '../containers/MerchantOnboard/redux/pgConfig/pgConfig.sagas';
import { editMerchantSagas } from '../containers/MerchantOnboard/redux/editMerchant/editMerchant.sagas';
import { dashBoardSaga } from '../containers/Dashboard/redux/dashboard.sagas';
import { commProfileSaga } from '../containers/CommProfile/redux/commProfile.sagas';
import { manageBinSaga } from '../containers/ManageBin/redux/manageBin.sagas';
import { bulkRefundSaga } from '../containers/BulkRefund/redux/bulkRefund.sagas';
import { auditTrailSaga } from '../containers/AuditTrail/redux/auditTrail.sagas';
import { profileSaga } from '../containers/Profile/redux/profile.sagas';
import { settlementSaga } from '../containers/Settlement/redux/settlement.sagas';
import { checkoutSaga } from '../containers/checkoutCustom/redux/checkout.sagas';
import { adjustmentsSaga } from '../containers/MerchantAdjustments/redux/adjustments.sagas';
import { merchantOnboardStatusSaga } from '../containers/MerchantOnboardStatus/redux/MerchantOnboardStatus.sagas';
import { InvoiceSaga } from '../containers/Invoice/redux/invoice.sagas';
import { MakerSaga } from '../containers/Maker/redux/maker.sagas';
import { merchantLegalEntitySaga } from '../containers/MerchantLegalEntity/redux/merchantLegalEntity.sagas';
import { CheckerSaga } from '../containers/Checker/redux/checker.sagas';
import { mandateSaga } from '../containers/Mandate/redux/mandates.sagas';
import { chargeBackSaga } from '../containers/Chargeback/redux/chargeback.sagas';
import { paymentGatewayCredentialsSaga } from '../containers/PaymentGatewayCredentials/redux/paymentGatewayCredentials.sagas';
import { bulkAccountVerificationSaga } from '../containers/BulkAccountVerification/redux/BulkAccountVerification.sagas';

import { tidSagas } from '../containers/TerminalOnboard/redux/TIDOnBoard.sagas';
import { paymentPageSagas } from '../containers/PaymentPage/redux/paymentPage.sagas';
import { authSagas } from './common/auth/auth.sagas';
import { staticDataSagas } from './common/staticData/staticData.sagas';
import entitySagas from 'containers/MerchantOnboard/redux/entity/entity.sagas';

function* rootSaga() {
    try {
        yield all([
            // Append all watcher sagas here
            authSagas(),
            merchantSagas(),
            userManagementSaga(),
            roleManagementSaga(),
            userVerificationSaga(),
            pgConfigDataSagas(),
            editMerchantSagas(),
            transactionsSaga(),
            refundSaga(),
            commProfileSaga(),
            manageBinSaga(),
            staticDataSagas(),
            roleVerificationSaga(),
            profileSaga(),
            paymentLinkSaga(),
            auditTrailSaga(),
            dashBoardSaga(),
            settlementSaga(),
            checkoutSaga(),
            adjustmentsSaga(),
            bulkRefundSaga(),
            merchantOnboardStatusSaga(),
            InvoiceSaga(),
            bulkPaymentLinkSaga(),
            MakerSaga(),
            CheckerSaga(),
            mandateSaga(),
            chargeBackSaga(),
            merchantLegalEntitySaga(),
            paymentGatewayCredentialsSaga(),
            bulkAccountVerificationSaga(),
            tidSagas(),
            paymentPageSagas(),
            entitySagas()
        ]);
    } catch (error) {
        console.error('saga error: ', error);
    }
}

export default rootSaga;
